import React from 'react';
import { IDjangoFile, IEmailAIExtractedData} from "../../../../types/common";
import ExtractedDataList from './ExtractedDataList';
import { Stack, Text } from '@chakra-ui/react';
import { downloadByUrl } from '@/utils/download';
import { FILE_TYPE } from '@/constants/common'

interface EmailAiExtractedDataDialogProps {
    emailAiExtractedData: IEmailAIExtractedData
}


const ProcessedFiles = ({ emailAiExtractedData }: EmailAiExtractedDataDialogProps) => {

    if (!emailAiExtractedData?.processedFiles?.length) return <Text>No files</Text>;

    const processedFilesListData = emailAiExtractedData.processedFiles.map((owner, i) => {
        const {
            fileType,
            filename,
            size,
            contentType,
            file,
        } = owner;


        return (
            {
                title: `File ${i+1}`,
                listData: [
                    { label: "File type", value: FILE_TYPE[fileType] },
                    { label: "File name", value: filename },
                    { label: "Size", value: size },
                    { label: "Content type", value: contentType },
                    { 
                        label: "File", 
                        value: <DownloadLink file={file}/>
                    },
                ]
            }
        )
    }) 


    return (
        <Stack gap={5}>
            {processedFilesListData?.map((owner) => (
                <Stack>
                    <Text>{owner.title}</Text>
                    <ExtractedDataList listData={owner.listData}/>
                </Stack>
            ))      
            }
        </Stack>

    )
}

const DownloadLink = ({ file }: { file: IDjangoFile}) => {

    return (
        <Text 
            textOverflow="ellipsis" 
            display={"block"}
            overflow="hidden" 
            whiteSpace="nowrap"
            cursor={"pointer"}
            textDecoration="underline"
            color={"brand.solid"}
            onClick={() => downloadByUrl(file?.url, file?.name)}
        >
            {file.name}
        </Text>
    )
} 


export default ProcessedFiles;